import anime from 'animejs';

export function scaleInit(el) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const tween = anime.set(elToTween, { scale: 0, transformOrigin: '50% 50%' });

  return tween;
}

export function scaleAnim(el) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const tween = anime({
    targets: elToTween,
    scale: 1,
  });

  return tween;
}
